import { UnitType } from '@eventops/athlinks-lib-units'
import { DistanceTypeId } from './types'

export const distanceTypeToUnitType = (distanceTypeId: DistanceTypeId) =>
  [DistanceTypeId.m, DistanceTypeId.km].includes(distanceTypeId)
    ? UnitType.METRIC
    : UnitType.IMPERIAL
